<script>
	import MainTitle from '../atoms/MainTitle.svelte';
	import { SendDataToPhp } from '../service';
	import PortfolioForm from '../molecules/PortfolioForm.svelte';
	import AllSubPortfolio from '../organisms/AllSubPortfolio.svelte';
	import { store } from '../store';
	import { getConnectorValue, getPhpFolderPath } from '../query';

	let subPortfolio = [];
	let nameValue = '';
	let positionValue;
	let isConnected = getConnectorValue();
	let max;

	store.subscribe((value) => {
		if (value != null) {
			if (value.portfolio !== undefined) {
				subPortfolio = value.portfolio;
				max = subPortfolio.length + 1;
				positionValue = max;
			}
		}
	});

	function SendData() {
		SendDataToPhp(getPhpFolderPath() + 'addCat.php', 'name=' + nameValue + '&pos=' + positionValue, 'protfolio');
	}
</script>

<MainTitle title="Portefolio" />

<!-- <HamburgerNav /> -->

{#if isConnected}
	<PortfolioForm onClick={SendData} bind:nameValue bind:positionValue maxValue={max} />
{/if}

<AllSubPortfolio bind:subPortfolio maxValue={max - 1} />
